import React from "react";
import "../styles/_gallery.scss";
interface Props {}

const GalleryGR: React.FC<Props> = (props) => {
  return (
    <div className="Gallery padding100" id="gallery">
      <h6>AL-MARE</h6>
      <h1>ΕΚΘΕΣΙΑΚΟΣ ΧΩΡΟΣ</h1>
      <div className="row g-0 toggleImg">
        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
          <div>
            <img
              src="gallery1.jpg"
              alt=""
              className="w-100 border border-white"
            />
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
          <div>
            <img
              src="gallery2.jpg"
              alt=""
              className="w-100 border border-white"
            />
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
          <div>
            <img
              src="gallery3.jpg"
              alt=""
              className="w-100 border border-white"
            />
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
          <div>
            <img
              src="gallery4.jpg"
              alt=""
              className="w-100 border border-white"
            />
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
          <div>
            <img
              src="gallery5.jpg"
              alt=""
              className="w-100 border border-white"
            />
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
          <div>
            <img
              src="gallery6.jpg"
              alt=""
              className="w-100 border border-white"
            />
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
          <div>
            <img
              src="gallery7.jpg"
              alt=""
              className="w-100 border border-white"
            />
          </div>
        </div>

        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
          <div>
            <img
              src="gallery8.jpg"
              alt=""
              className="w-100 border border-white"
            />
          </div>
        </div>
      </div>
      <div className="row g-0">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="3"
              aria-label="Slide 4"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="4"
              aria-label="Slide 5"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="5"
              aria-label="Slide 6"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="6"
              aria-label="Slide 7"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="7"
              aria-label="Slide 8"
            ></button>
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src="gallery1.jpg" className="d-block w-100" alt="gallery" />
            </div>
            <div className="carousel-item">
              <img src="gallery2.jpg" className="d-block w-100" alt="gallery" />
            </div>
            <div className="carousel-item">
              <img src="gallery3.jpg" className="d-block w-100" alt="gallery" />
            </div>
            <div className="carousel-item">
              <img src="gallery4.jpg" className="d-block w-100" alt="gallery" />
            </div>
            <div className="carousel-item">
              <img src="gallery5.jpg" className="d-block w-100" alt="gallery" />
            </div>
            <div className="carousel-item">
              <img src="gallery6.jpg" className="d-block w-100" alt="gallery" />
            </div>
            <div className="carousel-item">
              <img src="gallery7.jpg" className="d-block w-100" alt="gallery" />
            </div>
            <div className="carousel-item">
              <img src="gallery8.jpg" className="d-block w-100" alt="gallery" />
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GalleryGR;
